import Vue from 'vue'
import { GET_FIRSTINTERVENANTS, ERROR_XHR } from '../mutation-types.js'

export const getFirstintervenants = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('firstintervenant')
    .then(
      (response) => {
        dispatch(GET_FIRSTINTERVENANTS, response.json())
        resolve()
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/firstintervenantActions.js